<template>
    <div class="mx-4 mb-4">
        <signin-header />
        <signin-account :message="message" :redirectToPrevious="redirectToPrevious" />
    </div>
</template>
<script>
import SigninHeader from '@/components/SigninHeader';
import SigninAccount from '@/components/SigninAccount';

export default {
    name: 'app-signin',
    metaInfo: {
        title: 'Flowist - Simple team progress tracking for remote teams',
    },
    props: {
        message: String,
        redirectToPrevious: {
            type: Boolean,
            default: false,
        },
    },
    components: {
        SigninHeader,
        SigninAccount,
    },
};
</script>
